import orderBy from 'lodash/orderBy';

// Sorts by the display total (converted currency, VAT applied), so the order matches what the user sees.
export const sortOffers = (offers, sortPrice) => {
  const result = [...offers];
  if (sortPrice) {
    return orderBy(result, ['payment.renderTotal'], [sortPrice]);
  }
  return result;
};

export default sortOffers;
